// @flow
import React, { Component } from 'react';
import { make } from './ContentInjectors';

type Props = {
    asset: Object,
    options: Object,
};

export default class Content extends Component<Props> {
    render() {
        const content = make(this.props.asset, this.props.options);
        return <div>{content}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/Content.js